import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const RESPONSIVE_CONTAINER_PROPS = {
  size: ['xs', 'sm', 'md', 'lg', 'xl', 'xxl']
};
const responsiveContainerPropTypes = {
  children: PropTypes.node,
  fluid: PropTypes.bool,
  size: PropTypes.string,
  className: PropTypes.string
};
const ResponsiveContainer = ({
  children,
  fluid = false,
  size,
  className,
  ...otherProps
}) => {
  const baseClass = 'nui-responsive-container';
  const fluidClass = fluid && `${baseClass}--fluid`;
  const sizeClass = size && RESPONSIVE_CONTAINER_PROPS.size.includes(size) && `${baseClass}--${size}`;
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: cx([baseClass, fluidClass, sizeClass, className])
  }, otherProps), children);
};
ResponsiveContainer.propTypes = responsiveContainerPropTypes;
ResponsiveContainer.displayName = 'NuiResponsiveContainer';
var ResponsiveContainer$1 = ResponsiveContainer;

export { RESPONSIVE_CONTAINER_PROPS, ResponsiveContainer$1 as default };
